<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte nov odpis:
    </h2>

    <WriteoffFormForm
      @save="save"
      @cancel="cancel"
      ref="form"
    />

    <ConfirmDialog
      ref="confirmdialogunsaved"
      title="Opozorilo"
      text="Ali želiš izhod brez shranjevanja podatkov?"
      okBtnText="Razumem"
      :normal="false"
      v-model="showWarningModal"
    />
  </div>
</template>

<script>
import WriteoffFormForm from '@/components/WriteoffFormForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import { mapActions } from 'vuex'

export default {
  components: {
    WriteoffFormForm,
    ConfirmDialog
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      showWarningModal: false,
      shouldShowWarning: false,
    }
  },
  methods: {
    ...mapActions('writeoffForms', ['saveItem']),
    save ({ data, repeat = false }) {
      this.showWarningModal = false
      const redirect = repeat ? null : 'MyCompanyWriteoffFormsEdit'
      this.saveItem({ id: this.id, ...data })
        .then(item => {
          this.$refs.form.clearForm()
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          if (redirect) {
            this.$router.push({ name: redirect, params: { id: item.id } })
          } else {
            // this.$refs.form.clearForm()
            this.$refs.form.disabled = true
          }
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyWriteoffForms' })
    }
  },
  created () {
    this.showWarningModal = false
    this.asyncDataStatus_fetched()
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name === 'MyCompanyWriteoffFormsEdit' || to.name === 'MyCompanyWriteoffForms') {
      next()
    } else {
      this.showWarningModal = true
      next(await this.$refs.confirmdialogunsaved.pop())
    }
  }
}
</script>
